module.exports = __webpack_public_path__ + "static/media/project1.aeac7d33.png";